import { render, staticRenderFns } from "./IconMyFolder.vue?vue&type=template&id=3c74cd3d&"
import script from "./IconMyFolder.vue?vue&type=script&lang=js&"
export * from "./IconMyFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports